export default {
  common: {
    selfExplanation: "Explication de soi",
    prompt: "Invite",
    dontDisplayAgain: "Ne plus afficher cette invite.",
    continue: "Continuer",
    goBack: "Retour",

    cantFindTheCode: "Impossible de trouver le code: ",
    noContent: "Aucun contenu",

    promptDisabledReopen: "Vous pouvez la rouvrir dans la page [Accueil]->[Mon espace].",

    what: "Quoi :",
    why: "Pourquoi :",
    learn: "Apprendre",
    toLearnOpen: "Pour en savoir plus, veuillez ouvrir"
  },
  E1000: {
    topic: "Objectif",
    content_1_M:
      "Sélectionnez l'objectif de performance pour ce projet, tel qu'un refroidisseur, une centrale de refroidissement ou un système de chauffage. Les options de centrale de chauffage et de refroidissement et chauffage combinés seront bientôt disponibles.",
    content_2_M:
      "Cette sélection pilote le flux de travail iECM en définissant les limites du système, les entrées requises, la configuration d'équipement applicable et les indicateurs de performance utilisés pour évaluer les opportunités d'amélioration."
  },
  E10200: {
    topic: "Profil",
    content_1_M:
      "Configurez le profil du projet, y compris l'objectif, les conditions de conception, la configuration du refroidisseur, le profil météorologique et la configuration de pompage, le cas échéant.",
    content_2_M:
      "Ces informations aident iECM à adapter le flux de travail, les champs de saisie et la logique d'audit énergétique à l'objectif, au type de système et à la configuration d'équipement sélectionnés."
  },
  E10300: {
    topic: "Spécifications des équipements existants",
    content_1_M: "Saisissez les détails des équipements existants du site, y compris les refroidisseurs et autres composants de centrale applicables, selon l'objectif sélectionné.",
    content_2_M: "Cela aide iECM à comprendre le système actuel et à appliquer les bonnes données d'équipement pour l'audit énergétique et l'analyse de rénovation."
  },
  E10400: {
    topic: "Observation du site",
    content_1_M: "Capturez les conclusions clés, les recommandations, les avantages attendus et les photos justificatives de l'examen du site client.",
    content_2_M: "Ces notes expliquent pourquoi une rénovation est nécessaire et renforcent l'argumentaire commercial pour l'audit énergétique et la proposition."
  },
  E10500: {
    topic: "Configuration de référence",
    content_1_M:
      "Choisissez le meilleur chemin de données pour construire la référence énergétique actuelle du client. Utilisez les informations de charge de refroidissement ou les factures de consommation énergétique, puis définissez les mois d'exploitation et les tarifs d'électricité pour les périodes de pointe et hors pointe.",
    content_2_M: "Cette sélection définit le flux de travail de référence mensuel et aide iECM à construire le cas de référence pour l'audit énergétique et l'estimation des économies annuelles."
  },
  E10610: {
    topic: "Référence mensuelle",
    content_1_M:
      "Ajoutez ou modifiez le profil d'exploitation du mois de référence du client. iECM utilise ce profil pour estimer les charges de refroidissement du reste de l'année et calculer la puissance mensuelle du refroidisseur.",
    content_2_M: "Cela construit une référence crédible de l'état actuel afin que les économies d'énergie annuelles et la valeur de la rénovation puissent être comparées clairement."
  },
  E10611: {
    topic: "Calendrier d'exploitation",
    content_1_M:
      "Définissez quand le système du client fonctionne pour cette référence, par exemple en semaine, le week-end ou toute la semaine. Les jours d'exploitation mensuels sont calculés automatiquement.",
    content_2_M:
      "Les jours d'exploitation indiquent à quelle fréquence le système fonctionne chaque mois et tout au long de l'année, formant la base des calculs annuels de charge, d'énergie et d'économies."
  },
  E10612: {
    topic: "Heures d'exploitation",
    content_1_M: "Définissez le planning d'exploitation de 24 heures du mois de référence en marquant chaque heure comme pointe, hors pointe ou arrêt.",
    content_2_M: "Cela relie le fonctionnement du refroidisseur au profil météorologique approprié pour chaque période, aidant iECM à calculer la charge et la puissance plus précisément."
  },
  E10613: {
    topic: "Refroidisseur de référence",
    content_1_M:
      "Sélectionnez le refroidisseur du site utilisé pendant les périodes de pointe et hors pointe, puis choisissez le modèle proxy Carrier le plus proche pour représenter ses performances.",
    content_2_M: "iECM utilise le modèle proxy et les entrées de calibrage pour simuler les performances du refroidisseur du client et calculer la puissance de référence mensuelle plus précisément."
  },
  E10614: {
    topic: "Charge d'exploitation",
    content_1_M: "Définissez le nombre de refroidisseurs en fonctionnement chaque heure et leur taux de charge pour le jour de référence. iECM calcule ensuite la charge de refroidissement horaire.",
    content_2_M:
      "Cela aide iECM à construire le profil annuel de charge de refroidissement et à estimer combien de refroidisseurs sont nécessaires selon différentes conditions météorologiques mensuelles."
  },
  E10615: {
    topic: "Charge de refroidissement mensuelle",
    content_1_M: "Examinez la charge de refroidissement moyenne pondérée de chaque mois. Le mois de référence est basé sur les entrées horaires, tandis que les autres mois sont estimés par iECM.",
    content_2_M:
      "Ces charges mensuelles définissent la référence de demande de refroidissement utilisée pour estimer le fonctionnement du refroidisseur, l'utilisation d'énergie et les économies par rapport aux solutions de rénovation."
  },
  E10616: {
    topic: "Nombre mensuel de refroidisseurs",
    content_1_M:
      "Examinez le nombre minimum de refroidisseurs requis pour le fonctionnement en pointe et hors pointe chaque mois, selon la charge de refroidissement mensuelle et la capacité de refroidisseurs disponible.",
    content_2_M: "Cela aide iECM à estimer comment les refroidisseurs existants fonctionnent tout au long de l'année et soutient les calculs mensuels de puissance et d'énergie de référence."
  },
  E10617: {
    topic: "Puissance du refroidisseur",
    content_1_M:
      "Examinez la puissance moyenne mensuelle du refroidisseur pour les périodes de pointe et hors pointe, calculée à partir du modèle proxy du refroidisseur, de la charge de refroidissement et du nombre de refroidisseurs.",
    content_2_M: "Ce profil de puissance est utilisé pour estimer l'utilisation d'énergie du refroidisseur avant rénovation et comparer les économies aux solutions de rénovation."
  },
  E10620: {
    topic: "Référence mensuelle",
    content_1_M: "Ajoutez ou modifiez les configurations de référence mensuelle selon les modèles d'exploitation du client, comme le fonctionnement en semaine et le week-end.",
    content_2_M:
      "Ces références organisent le flux de travail des factures de services publics et aident iECM à construire la référence énergétique actuelle pour comparer les économies annuelles et la valeur de la rénovation."
  },
  E10621: {
    topic: "Calendrier d'exploitation",
    content_1_M:
      "Définissez quand le système du client fonctionne pour cette référence, par exemple en semaine, le week-end ou toute la semaine. Les jours d'exploitation mensuels sont calculés automatiquement.",
    content_2_M:
      "Les jours d'exploitation indiquent à quelle fréquence le système fonctionne chaque mois et tout au long de l'année, formant la base des calculs annuels de charge, d'énergie et d'économies."
  },
  E10622: {
    topic: "Heures de fonctionnement",
    content_1_M: "Saisissez les heures de fonctionnement quotidiennes pour les périodes de pointe et hors pointe de chaque mois, selon le planning d'exploitation du client.",
    content_2_M: "Cela relie le fonctionnement du refroidisseur au profil météorologique approprié pour chaque période, aidant iECM à calculer la puissance plus précisément."
  },
  E10623: {
    topic: "Refroidisseur de référence",
    content_1_M:
      "Sélectionnez le refroidisseur du site utilisé pendant les périodes de pointe et hors pointe, puis choisissez le modèle proxy Carrier le plus proche pour représenter ses performances.",
    content_2_M:
      "iECM utilise le modèle proxy et les entrées de calibrage pour simuler les performances du refroidisseur du client et calculer la charge de refroidissement de référence mensuelle plus précisément."
  },
  E10624: {
    topic: "Consommation d’énergie",
    content_1_M: "Saisissez la consommation énergétique mensuelle du client pour les périodes de pointe et hors pointe à l'aide des données de factures de services publics.",
    content_2_M:
      "Cela aide iECM à convertir les données de factures en une référence d'exploitation, y compris la puissance estimée du refroidisseur, le nombre de refroidisseurs requis et la demande de charge de refroidissement."
  },
  E10625: {
    topic: "Puissance du refroidisseur",
    content_1_M:
      "Examinez la puissance moyenne pondérée mensuelle du refroidisseur calculée à partir des données de factures de services publics du client pour les périodes de pointe et hors pointe.",
    content_2_M:
      "Cette puissance moyenne pondérée est utilisée pour estimer le fonctionnement du refroidisseur, la demande de charge de refroidissement et les économies par rapport aux solutions de rénovation."
  },
  E10626: {
    topic: "Nombre mensuel de refroidisseurs",
    content_1_M:
      "Examinez le nombre minimum de refroidisseurs requis pour le fonctionnement en pointe et hors pointe chaque mois, selon la puissance de refroidissement moyenne mensuelle et la puissance de refroidisseurs disponible.",
    content_2_M:
      "Cela aide iECM à estimer comment les refroidisseurs existants fonctionnent tout au long de l'année et soutient la référence mensuelle de charge de refroidissement et les calculs d'énergie."
  },
  E10627: {
    topic: "Charge de refroidissement mensuelle",
    content_1_M:
      "Examinez la charge de refroidissement moyenne pondérée mensuelle dérivée des données de factures de services publics, des performances du refroidisseur proxy, de la puissance mensuelle du refroidisseur et du nombre de refroidisseurs.",
    content_2_M:
      "Ce profil de charge de refroidissement représente la même demande du bâtiment avant et après rénovation, permettant une comparaison équitable entre les équipements actuels et proposés."
  },
  E10628: {
    topic: "Puissance auxiliaire",
    content_1_M:
      "Saisissez la puissance d'exploitation moyenne pondérée réelle (kW) des équipements auxiliaires, tels que les pompes et les tours de refroidissement, pendant les périodes de pointe et hors pointe.",
    content_2_M:
      "Cela aide iECM à inclure l'utilisation d'énergie des équipements auxiliaires dans la référence actuelle et à calculer l'utilisation totale d'énergie avant rénovation plus précisément."
  },
  E10700: {
    topic: "Aperçu de la référence",
    content_1_M:
      "Examinez et téléchargez les résultats de l'audit énergétique de référence avant rénovation, y compris la charge de refroidissement horaire, la puissance estimée et la charge et la puissance mensuelles par type d'équipement.",
    content_2_M: "Cela confirme les résultats de la référence avant rénovation et génère un rapport d'audit énergétique prêt pour le client avant le début de la modélisation après rénovation."
  },
  E10800: {
    topic: "Configurer les conditions d'exploitation",
    content_1_M:
      "Sélectionnez le nouveau type de refroidisseur et définissez les conditions d'exploitation après rénovation, telles que la température de l'eau glacée et les réglages côté condenseur.",
    content_2_M: "Cela aide iECM à configurer la disposition après rénovation et à estimer les performances selon le type d'équipement sélectionné."
  },
  E10900: {
    topic: "Définir le nouvel équipement",
    content_1_M:
      "Ajoutez et définissez le nouvel équipement utilisé dans la solution de rénovation, y compris les refroidisseurs, les pompes et les tours de refroidissement le cas échéant. Chaque entrée représente une unité d'équipement.",
    content_2_M:
      "Définissez chaque option d'équipement une fois. iECM calcule les quantités d'exploitation requises et les utilise pour estimer les performances de rénovation, les économies d'énergie et le ROI."
  },
  E10901: {
    topic: "e-CAT numérique",
    content_1_M: "Choisissez un nouveau refroidisseur dans l'e-CAT numérique, définissez les conditions de conception et le prix de vente, et examinez sa courbe de performance.",
    content_2_M:
      "Cela rend la sélection du refroidisseur plus rapide et plus facile tout en fournissant les données de performance nécessaires à l'analyse de rénovation et au calcul des économies. Le prix de vente unitaire est utilisé pour estimer le CAPEX total du projet."
  },
  E10902: {
    topic: "Mois du cluster",
    content_1_M:
      "Utilisez la mois du cluster lorsque le refroidisseur souhaité n'est pas disponible dans la bibliothèque e-CAT numérique. Regroupez les mois similaires, puis saisissez les détails du refroidisseur et les données de performance e-CAT.",
    content_2_M:
      "Le regroupement des mois réduit les saisies e-CAT répétées, tandis que la saisie manuelle permet à iECM d'analyser des refroidisseurs personnalisés pour l'analyse de rénovation et le calcul des économies. Le prix de vente unitaire est utilisé pour estimer le CAPEX total."
  },
  E10903: {
    topic: "Pompe",
    content_1_M: "Définissez la nouvelle pompe et reliez-la au refroidisseur qu'elle prendra en charge dans la solution de rénovation.",
    content_2_M: "Cela aide iECM à modéliser correctement la solution proposée en associant chaque pompe au refroidisseur en fonctionnement approprié."
  },
  E10904: {
    topic: "Tour de refroidissement",
    content_1_M: "Définissez la nouvelle tour de refroidissement et reliez-la au refroidisseur qu'elle prendra en charge dans la solution de rénovation.",
    content_2_M: "Cela aide iECM à modéliser correctement la solution proposée en associant chaque tour de refroidissement au refroidisseur en fonctionnement approprié."
  },
  E11000: {
    topic: "Solution de rénovation",
    content_1_M:
      "Examinez les solutions de rénovation générées par iECM, classez-les par efficacité, ROI ou investissement, et complétez la configuration requise pour chaque option. Générez le rapport ECM ou reconfigurez une solution pour une disposition personnalisée.",
    content_2_M: "Cela vous aide à choisir la proposition la plus solide pour le client, à affiner le ROI, la VAN et la configuration proposée, et à générer le rapport ECM final."
  },
  E12000: {
    topic: "Solution reconfigurée",
    content_1_M:
      "Configurez manuellement une solution de rénovation en sélectionnant le refroidisseur associé et la quantité maximale de fonctionnement pour chaque référence et période d'exploitation.",
    content_2_M: "Cela vous donne la flexibilité d'adapter la proposition lorsque la solution générée automatiquement n'est pas la mieux adaptée au client."
  },
  E11001: {
    topic: "Configuration de rénovation",
    content_1_M:
      "Examinez la configuration détaillée de la solution de rénovation, y compris la charge de refroidissement maximale, la capacité proposée du refroidisseur et les nombres mensuels d'équipements en fonctionnement.",
    content_2_M: "Cela confirme comment le système proposé est dimensionné et exploité avant d'être utilisé pour l'analyse financière et le rapport ECM final."
  },
  E11002: {
    topic: "ROI et VAN",
    content_1_M:
      "Examinez et mettez à jour les performances financières sur le cycle de vie de la solution, y compris les économies d'énergie, les économies de coûts, le ROI, la période de récupération et la VAN pour la centrale de refroidissement ou le refroidisseur.",
    content_2_M: "Cela montre au client comment la solution améliore l'efficacité, réduit les coûts d'exploitation et offre une valeur financière à long terme, y compris le ROI et la VAN."
  },
  E11003: {
    topic: "Détails des équipements proposés",
    content_1_M: "Définissez la portée et la configuration détaillées de la rénovation en sélectionnant quels équipements existants resteront et quels nouveaux équipements les remplaceront.",
    content_2_M: "Cela clarifie les changements d'équipements proposés et aide à créer un plan de rénovation et un rapport ECM complets et prêts pour le client."
  },
  E11004: {
    topic: "Configuration proposée",
    content_1_M: "Saisissez les hypothèses d'analyse, les détails du système et les mesures de conservation d'énergie à inclure dans le rapport ECM final.",
    content_2_M: "Cela aide à créer un rapport complet et prêt pour le client qui explique clairement la base de la rénovation, les mesures proposées et la valeur attendue."
  },

  // HEATING
  E2000: {
    topic: "Objectif",
    content_1_M:
      "Sélectionnez l’objectif de performance du projet. Indiquez si l’évaluation porte sur un seul groupe froid, une centrale de production d’eau glacée ou un système de chauffage. Les options de rénovation par pompe à chaleur et de centrale intégrée de refroidissement et de chauffage seront bientôt disponibles.",
    content_2_M:
      "Ce choix guide la suite du flux de travail iECM Spec Builder. Il détermine le périmètre du système, les données utilisateur requises, la configuration d’équipement applicable et les indicateurs de performance utilisés pour évaluer les possibilités d’amélioration."
  },
  E20200: {
    topic: "Profil",
    content_1_M:
      "Saisissez les informations de base et les hypothèses de conception du projet, notamment son objectif, le site, les données météorologiques, l’application de chauffage, les conditions de conception et la configuration du système.",
    content_2_M: "Ces données permettent à iECM Spec Builder d’adapter le flux de travail et les calculs de chauffage au site, au climat, à l’application et au système existant."
  },
  E20300: {
    topic: "Caractéristiques des équipements existants",
    content_1_M:
      "Ajoutez les équipements de chauffage existants et saisissez les principales caractéristiques de chaque unité, notamment le type, la puissance, la quantité, la source de combustible ou d’énergie et les données de rendement.",
    content_2_M: "Ces informations définissent le système de chauffage actuel et fournissent les données nécessaires pour établir la référence et évaluer les options de remplacement."
  },
  E20400: {
    topic: "Observations sur site",
    content_1_M: "Consignez les constats sur site, les problèmes observés, les recommandations, les bénéfices attendus et les photos justificatives issus de la visite du site client.",
    content_2_M: "Les observations sur site expliquent les motifs pratiques de la rénovation et apportent des éléments justificatifs pour l’audit énergétique et la proposition client."
  },
  E20500: {
    topic: "Configuration de la référence",
    content_1_M:
      "Sélectionnez la voie de données de référence disponible : la voie A utilise les informations de charge de chauffage, tandis que la voie B utilise les données de consommation d’énergie. Définissez ensuite les mois de fonctionnement et les prix ou tarifs d’énergie applicables.",
    content_2_M: "La voie sélectionnée détermine comment la référence mensuelle de chauffage est élaborée et comment les coûts énergétiques annuels et les économies sont évalués."
  },
  E20610: {
    topic: "Référence mensuelle",
    content_1_M:
      "Ajoutez ou modifiez le profil mensuel de fonctionnement représentatif utilisé pour établir la référence de chauffage et estimer les conditions de fonctionnement des autres mois de l’année.",
    content_2_M: "Un profil de fonctionnement représentatif fournit une base cohérente pour estimer les besoins annuels de chauffage, la consommation d’énergie et les économies liées à la rénovation."
  },
  E20611: {
    topic: "Calendrier de fonctionnement",
    content_1_M:
      "Définissez les jours de fonctionnement du système, par exemple les jours ouvrés, les week-ends ou toute la semaine. iECM Spec Builder calcule ensuite le nombre de jours de fonctionnement correspondant pour chaque mois.",
    content_2_M:
      "Les jours de fonctionnement déterminent la fréquence d’utilisation du système de chauffage et constituent une donnée clé pour calculer les charges, consommations d’énergie et économies mensuelles et annuelles."
  },
  E20612: {
    topic: "Heures de fonctionnement",
    content_1_M: "Saisissez, pour chaque mois, les heures de fonctionnement quotidiennes en périodes pleines et creuses, selon le programme réel du client.",
    content_2_M:
      "Cette répartition associe le fonctionnement du chauffage aux périodes et conditions météorologiques appropriées, améliorant ainsi la précision des calculs de charge, de consommation et de coût."
  },
  E20613: {
    topic: "Fonctionnement des chaudières",
    content_1_M:
      "Sélectionnez la chaudière existante ou tout autre équipement de chauffage fonctionnant en périodes pleines et creuses. Confirmez ensuite les paramètres de fonctionnement et les données de performance applicables.",
    content_2_M:
      "Cette étape relie l’équipement existant à la demande mensuelle de chauffage, ce qui permet à iECM Spec Builder d’estimer son fonctionnement de référence et sa consommation d’énergie."
  },
  E20615: {
    topic: "Charge mensuelle de chauffage",
    content_1_M:
      "Examinez la charge moyenne de chauffage en périodes pleines et creuses pour chaque mois. Le mois représentatif repose sur le profil de charge saisi, tandis que iECM Spec Builder estime les autres mois.",
    content_2_M:
      "Le profil de charge mensuel définit la référence de demande de chauffage utilisée pour déterminer le fonctionnement des équipements, calculer la consommation d’énergie et comparer les solutions de rénovation."
  },
  E20616: {
    topic: "Nombre mensuel de chaudières",
    content_1_M:
      "Examinez le nombre minimal de chaudières ou d’unités de chauffage existantes requis en périodes pleines et creuses pour chaque mois, selon la charge de chauffage et la puissance disponible.",
    content_2_M: "Le nombre d’équipements montre comment le système existant répond à la demande mensuelle et étaye le calcul énergétique de référence."
  },
  E20617: {
    topic: "Consommation mensuelle d’énergie",
    content_1_M:
      "Examinez la consommation mensuelle d’énergie estimée en périodes pleines et creuses. L’estimation repose sur la charge de chauffage, le fonctionnement et les performances des équipements existants.",
    content_2_M: "Cette étape établit la référence énergétique avant rénovation utilisée pour calculer les coûts énergétiques annuels et comparer les économies offertes par les solutions proposées."
  },
  E20623: {
    topic: "Fonctionnement des chaudières",
    content_1_M:
      "Sélectionnez la chaudière existante ou tout autre équipement de chauffage associé à la consommation d’énergie déclarée. Confirmez ensuite les paramètres de fonctionnement et les données de performance applicables.",
    content_2_M:
      "Cette étape relie la référence de consommation d’énergie à l’équipement de chauffage réel et permet de convertir l’énergie consommée en demande de chauffage et en exigences de fonctionnement."
  },
  E20627: {
    topic: "Consommation mensuelle d’énergie",
    content_1_M: "Saisissez ou examinez la consommation mensuelle d’énergie de chauffage du client et, le cas échéant, sa répartition entre périodes pleines et creuses.",
    content_2_M:
      "Les données de consommation constituent la principale entrée de référence pour estimer la demande mensuelle de chauffage, les coûts énergétiques actuels et les économies liées à la rénovation."
  },
  E20626: {
    topic: "Nombre mensuel de chaudières",
    content_1_M: "Examinez le nombre estimé de chaudières ou d’unités de chauffage existantes requis en périodes pleines et creuses pour chaque mois.",
    content_2_M: "Cela montre comment les équipements existants devraient fonctionner pour répondre à la demande déduite de la référence de consommation d’énergie."
  },
  E20625: {
    topic: "Charge mensuelle de chauffage",
    content_1_M: "Examinez la charge mensuelle de chauffage estimée à partir des données de consommation d’énergie, du profil de fonctionnement et des performances des équipements existants.",
    content_2_M: "Le profil de charge déduit fournit une base commune pour la demande de chauffage, permettant de dimensionner et de comparer les solutions de rénovation proposées."
  },
  E20700: {
    topic: "Aperçu de la référence",
    content_1_M:
      "Examinez les résultats de référence, notamment la demande mensuelle de chauffage, la consommation d’énergie et les coûts énergétiques. Téléchargez ensuite le rapport d’audit énergétique de référence.",
    content_2_M: "Vous pouvez ainsi vérifier le cas de référence avant rénovation avant de poursuivre l’analyse des équipements et solutions de rénovation proposés."
  },
  E20800: {
    topic: "Définir les conditions de fonctionnement",
    content_1_M:
      "Sélectionnez le type de pompe à chaleur proposé et définissez les conditions de fonctionnement après rénovation, notamment les températures côté charge et côté source, le cas échéant.",
    content_2_M:
      "Les conditions de fonctionnement déterminent la puissance et le rendement de la pompe à chaleur. Elles sont donc essentielles pour calculer avec précision les performances du système proposé."
  },
  E20900: {
    topic: "Définir les nouveaux équipements",
    content_1_M: "Ajoutez les options de pompes à chaleur proposées et définissez les principales caractéristiques de chaque unité.",
    content_2_M:
      "Chaque option n’est définie qu’une seule fois afin que iECM Spec Builder puisse déterminer le nombre d’unités requis et évaluer les performances, les économies, l’investissement et le retour financier."
  },
  E20901: {
    topic: "Sélection de la pompe à chaleur : digital e-CAT",
    content_1_M: "Sélectionnez une pompe à chaleur dans digital e-CAT, définissez les conditions de conception et le prix de vente de l’unité, puis examinez les données de performance disponibles.",
    content_2_M:
      "digital e-CAT fournit des données cohérentes de sélection et de performance pour l’analyse de rénovation, tandis que le prix de vente contribue à l’estimation des dépenses d’investissement du projet (CAPEX)."
  },
  E20902: {
    topic: "Sélection de la pompe à chaleur : conception manuelle et regroupement des mois",
    content_1_M:
      "Utilisez la conception manuelle lorsque la pompe à chaleur requise n’est pas disponible dans digital e-CAT. Regroupez les mois présentant des conditions de fonctionnement similaires, puis saisissez les données d’équipement et de performance pour chaque groupe.",
    content_2_M:
      "Le regroupement des mois réduit les saisies répétitives tout en permettant d’évaluer un équipement personnalisé dans des conditions représentatives sur l’année. Le prix de vente contribue à l’estimation des dépenses d’investissement (CAPEX)."
  },
  E21000: {
    topic: "Solutions de rénovation",
    content_1_M:
      "Examinez les solutions générées par iECM Spec Builder et comparez-les ou classez-les selon le rendement, le retour financier ou l’investissement. Finalisez la configuration requise, puis générez le rapport ECM. Vous pouvez également reconfigurer une solution manuellement.",
    content_2_M:
      "Cette étape vous aide à identifier une proposition client adaptée, à affiner la configuration des équipements et les hypothèses financières, puis à produire le rapport final de rénovation."
  },
  E22000: {
    topic: "Solution reconfigurée",
    content_1_M:
      "Configurez manuellement une solution de rénovation en sélectionnant les équipements proposés et en définissant le nombre maximal d’unités pouvant fonctionner pour chaque mois de référence et chaque période de fonctionnement.",
    content_2_M:
      "Cette fonction offre la flexibilité nécessaire pour créer une configuration spécifique au client lorsqu’une solution générée automatiquement ne répond pas entièrement aux besoins du projet."
  },
  E21001: {
    topic: "Configuration de la rénovation",
    content_1_M:
      "Examinez la configuration détaillée de la solution, notamment la charge maximale de chauffage, la puissance des pompes à chaleur proposées et le nombre mensuel d’équipements en fonctionnement.",
    content_2_M: "Cela confirme que le système proposé est correctement dimensionné et configuré avant de finaliser l’évaluation financière et le rapport."
  },
  E21002: {
    topic: "ROI et NPV",
    content_1_M:
      "Examinez et mettez à jour les résultats financiers du cycle de vie, notamment les économies d’énergie et de coûts, le coût d’investissement, le retour sur investissement (ROI), le temps de retour et la valeur actuelle nette (NPV).",
    content_2_M:
      "Cette analyse montre le potentiel de la solution à réduire les coûts d’exploitation et à créer une valeur financière à long terme, aidant ainsi les clients à prendre des décisions d’investissement éclairées."
  },
  E21004: {
    topic: "Détails des équipements proposés",
    content_1_M:
      "Définissez le périmètre détaillé de la rénovation en précisant quels équipements existants seront conservés et quels équipements proposés seront ajoutés ou utilisés en remplacement.",
    content_2_M: "Cette étape documente clairement les modifications d’équipement et facilite la préparation d’un plan de rénovation complet, prêt à être présenté au client, ainsi que du rapport ECM."
  },
  // wizard mode related
  E13000: {
    topic: "Configuration rapide",
    content_1_M:
      "La configuration rapide rassemble les informations essentielles sur le projet, les équipements existants et les équipements proposés, nécessaires à la création d’une référence initiale et d’un modèle de rénovation.",
    content_2_M:
      "Elle permet à iECM de réaliser une première évaluation avec des données de site limitées. iECM utilise les données fournies et les modèles de référence pour générer des hypothèses initiales, qui peuvent être examinées et ajustées avant le calcul."
  },
  E13001: {
    topic: "Vérifier les hypothèses",
    content_1_M:
      "Saisissez les données minimales requises, notamment le secteur du bâtiment, le parcours estimé, le refroidisseur du site, le refroidisseur de référence, le refroidisseur proposé et le tarif mensuel.",
    content_2_M: "Associées aux hypothèses automatisées et aux valeurs par défaut, ces données permettent d’effectuer rapidement les calculs et de générer les rapports."
  },
  E13002: {
    topic: "Résultats de l’évaluation",
    content_1_M:
      "Saisissez les données minimales requises, notamment le secteur du bâtiment, le parcours estimé, le refroidisseur du site, le refroidisseur de référence, le refroidisseur proposé et le tarif mensuel.",
    content_2_M: "Associées aux hypothèses automatisées et aux valeurs par défaut, ces données permettent d’effectuer rapidement les calculs et de générer les rapports."
  }
}



// WEBPACK FOOTER //
// ./src/locale/explan/fr.js